var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.getCurrentRelatedProducts.length
    ? _c(
        "section",
        { staticClass: "new-related-collection container px20" },
        [
          _vm.getCurrentRelatedProducts && _vm.getCurrentRelatedProducts.length
            ? _c("products-slider", {
                attrs: {
                  title: _vm.heading,
                  products: _vm.getCurrentRelatedProducts,
                  config: _vm.configSlider,
                  isBadge: true,
                  isH4: true,
                  categoryProps: _vm.categoryProps,
                  id: "related"
                }
              })
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }